"use client"

import { useInView } from "react-intersection-observer"
import { Users, MapPin, Clock, DollarSign } from "lucide-react"
import "../assets/css/careers.css" 

export default function Careers() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  // const jobOpenings = [
  //   {
  //     title: "Agricultural Specialist",
  //     department: "Operations",
  //     location: "Colombo, Sri Lanka",
  //     type: "Full-time",
  //     salary: "Competitive",
  //     description: "Join our team to develop sustainable farming practices and support local farmers.",
  //     requirements: ["Bachelor's degree in Agriculture", "3+ years experience", "Knowledge of sustainable farming"],
  //   }
  // ]

  // To test the "no openings" message, set jobOpenings to an empty array:
  const jobOpenings: any[] = []

  return (
    <section id="careers" ref={ref} className="careers-section">
      <div className="careers-container">
        <a
          href="/"
          className="back-home-link"
          onMouseOver={e => (e.currentTarget.style.background = "#166534")}
          onMouseOut={e => (e.currentTarget.style.background = "#15803d")}
        >
          ← Back to Home
        </a>
        <div className="section-header">
          <h2 className={`section-title ${inView ? "visible" : ""}`}>Join Our Team</h2>
          <div className={`section-divider ${inView ? "visible" : ""}`}></div>
          <p className={`section-slogan ${inView ? "visible" : ""}`}>"Plant the Seeds of Your Success With Us"</p>
          <p className={`careers-subtitle ${inView ? "visible" : ""}`}>
            Be part of our mission to revolutionize sustainable agriculture and bring premium quality products to the
            world
          </p>
        </div>

        <div className="careers-content">
          <div className={`careers-intro ${inView ? "visible" : ""}`}>
            <h3>Why Work With Us?</h3>
            <div className="benefits-grid">
              <div className="benefit-item">
                <Users className="benefit-icon" />
                <h4>Great Team</h4>
                <p>Work with passionate professionals dedicated to sustainable agriculture</p>
              </div>
              <div className="benefit-item">
                <DollarSign className="benefit-icon" />
                <h4>Competitive Benefits</h4>
                <p>Attractive salary packages with performance bonuses</p>
              </div>
              <div className="benefit-item">
                <Clock className="benefit-icon" />
                <h4>Work-Life Balance</h4>
                <p>Flexible working arrangements and supportive work environment</p>
              </div>
            </div>
          </div>

          <div className={`job-openings ${inView ? "visible" : ""}`}>
            <h3>Current Openings</h3>
            {jobOpenings.length === 0 ? (
              <div className="no-openings-message">
              <div className="no-openings-container">
                <h4 className="no-openings-title">We're Not Hiring Right Now — But We'd Still Love to Hear from You</h4>
                <p className="no-openings-text">
                  While we don't have any current openings, we're always on the lookout for passionate and talented individuals. 
                  If you're interested in joining our team, feel free to send us your CV — we'll keep it on file and reach out 
                  if a suitable opportunity comes up.
                </p>
                <div className="no-openings-contact">
                  <span className="email-icon">📧</span>
                  <span className="email-text">Submit your CV to</span>
                  <a href="mailto:info@gbceylon.com" className="email-link">info@gbceylon.com</a>
                </div>
              </div>
            </div>
            ) : (
              <div className="jobs-grid">
                {jobOpenings.map((job, index) => (
                  <div
                    key={index}
                    className={`job-card ${inView ? "visible" : ""}`}
                    style={{
                      transitionDelay: `${500 + index * 150}ms`,
                    }}
                  >
                    <div className="job-header">
                      <h4 className="job-title">{job.title}</h4>
                      <span className="job-department">{job.department}</span>
                    </div>
                    <div className="job-meta">
                      <div className="job-meta-item">
                        <MapPin className="meta-icon" />
                        <span>{job.location}</span>
                      </div>
                      <div className="job-meta-item">
                        <Clock className="meta-icon" />
                        <span>{job.type}</span>
                      </div>
                      <div className="job-meta-item">
                        <DollarSign className="meta-icon" />
                        <span>{job.salary}</span>
                      </div>
                    </div>
                    <p className="job-description">{job.description}</p>
                    <div className="job-requirements">
                      <h5>Requirements:</h5>
                      <ul>
                        {job.requirements.map((req: string, reqIndex: number) => (
                          <li key={reqIndex}>{req}</li>
                        ))}
                      </ul>
                    </div>
                    <button className="apply-button">Apply Now</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="bg-leaf bg-leaf-1"></div>
      <div className="bg-leaf bg-leaf-2"></div>
    </section>
  )
}
